import _export from '../internals/export.js';
import anObject$1 from '../internals/an-object.js';
import objectIsExtensible from '../internals/object-is-extensible.js';

var $ = _export;
var anObject = anObject$1;
var $isExtensible = objectIsExtensible; // `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible

$({
  target: 'Reflect',
  stat: true
}, {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible(target);
  }
});
